<template>
  <div :class="[module + '-sub-panel']" style="height: 90vh; overflow-y: auto;">
    <p class="sub-panel-title"></p>

    <div
      v-for="insight in insights"
      :key="insight.id || insight.type"
      :class="[module + '-containers-content']"
    >
      <div :class="[module + '-info-container']">
        <span>{{ insight.title || getPromptTypeLabel(insight.type) }}</span>
        <div style="display: flex; flex-direction: row; align-items: center; margin-top: 10px">
          <img src="/lamp-icon.png" alt="Ícone Insights" class="info-image" style="width: 20px" />
          <span :class="[module + '-info-text']">
            {{ getInsightCount(insight) }}
            {{ getInsightCount(insight) > 1 ? 'insights' : 'insight' }}
          </span>
        </div>
      </div>
      <div class="button-container">
        <button
          class="open-button"
          @click="$emit('open-insights', insight)"
        >
          <img src="/lamp-icon.png" alt="Ícone" class="button-icon" />
          <span>Abrir</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightsList',
  props: {
    module: {
      type: String,
      required: true
    },
    insights: {
      type: Array,
      default: () => []
    },
    getPromptTypeLabel: {
      type: Function,
      required: true
    }
  },
  methods: {
    getInsightCount(insight) {
      if (insight.items) {
        return insight.items.length;
      }
      if (insight.length) {
        return insight.length;
      }
      return 1;
    }
  }
}
</script>

<style scoped>
.info-image {
  margin-right: 5px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: auto;
  width: 20%;
}

.open-button {
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background-color: #ffffff;
  color: #1c3d5a;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
}

.open-button:hover {
  background-color: #f0f5ff;
  color: #0047ab;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.button-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  color: #f9b234;
}

[class$="-containers-content"] {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: white;
  padding: 20px 24px;
  margin: 14px 0;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;
  transition: all 0.3s ease;
  border-left: 4px solid #1c3d5a;
}

[class$="-containers-content"]:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

[class$="-info-container"] {
  display: flex;
  flex-direction: column;
  width: 80%;
  padding-right: 20px;
}

[class$="-info-container"] > span {
  font-size: 17px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  word-break: break-word;
  margin-bottom: 12px;
}
</style>